<div class="stocks-table">
	<div class="filters">
		@if (widget()?.assetClass) {
			<app-asset-type [widget]="widget()" />
		}
	</div>

	<app-table
		[statesColumns]="statesColumns()"
		[settings]="{
			size: 'sm',
			spreadContent: 'space-between',
			rowBorder: true,
			emptyTextPath: 'positions.empty',
			defaultSort: widget()?.settings?.stocks?.activeSort ?? {
				prop: 'unrealized_plpc',
				type: 'desc',
			},
		}"
		[items]="positions()"
		[isLoading]="isLoadingPositions()"
		(onChangeSort)="changeSort($event)"
	>
		<app-table-column
			[settings]="{
				titlePath: 'positions.ticker',
				column: positionColumnsEnum.ticker,
				canSort: true,
				propSort: 'symbol',
				minWidthPx: 80,
				maxWidthPx: 90,
			}"
		>
			<ng-template let-item="item">
				<div class="ticker-column">
					<div class="ticker-text">
						<span
							class="symbol"
							(click)="setLiveTicker(item)"
							>{{ item.symbol }}</span
						>
						<div class="ticker-sl-tp">
							@if (checkHasStopLoss(item)) {
								<img
									class="ticker-sl-tp__img"
									src="/images/icons/sl.svg"
									alt="sl"
								/>
							}
							@if (checkHasTakeProfit(item)) {
								<img
									class="ticker-sl-tp__img"
									src="/images/icons/tp.svg"
									alt="tp"
								/>
							}
						</div>
					</div>
					<span class="exchange">{{ item.exchange }}</span>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.marketValue',
				column: positionColumnsEnum.marketValue,
				canSort: true,
				propSort: 'market_value',
				minWidthPx: 80,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					class="text"
					>{{ item.market_value | price }}</span
				>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.quantity',
				column: positionColumnsEnum.quantity,
				canSort: true,
				propSort: 'qty',
				minWidthPx: 80,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					class="text"
					>{{ item.qty | quantity }}</span
				>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.priceAveragePrice',
				column: positionColumnsEnum.priceAveragePrice,
				canSort: true,
				propSort: 'current_price',
				minWidthPx: 100,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="column">
					<span
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						class="text"
						>{{ item.current_price | price }}</span
					>
					<span
						secret
						[isSecret]="isSecret()"
						[secretCount]="3"
						class="sub-text"
						>{{ item.avg_entry_price | price }}</span
					>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.share',
				column: positionColumnsEnum.share,
				canSort: true,
				propSort: 'share',
				minWidthPx: 80,
				maxWidthPx: 80,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span class="text">{{ item.portfolio_allocation | percent: true }}</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.profitabilityPerDay',
				column: positionColumnsEnum.profitabilityPerDay,
				canSort: true,
				propSort: 'unrealized_intraday_plpc',
				minWidthPx: 100,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="column">
					<span
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						highlight
						[isPositive]="calcProfitabilityDollar(item, true) > 0"
						[isNegative]="calcProfitabilityDollar(item, true) < 0"
						[isNeutral]="!calcProfitabilityDollar(item, true)"
						class="text"
					>
						{{ calcProfitabilityDollar(item, true) | profit: 'dollar' }}
					</span>
					<span
						highlight
						[isPositive]="calcProfitabilityPercent(item, true) > 0"
						[isNegative]="calcProfitabilityPercent(item, true) < 0"
						[isNeutral]="!calcProfitabilityPercent(item, true)"
						class="sub-text"
					>
						{{ calcProfitabilityPercent(item, true) | profit: 'percent' }}
					</span>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.profitability',
				column: positionColumnsEnum.profitability,
				canSort: true,
				propSort: 'unrealized_plpc',
				minWidthPx: 100,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="column">
					<span
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						highlight
						[isPositive]="calcProfitabilityDollar(item) > 0"
						[isNegative]="calcProfitabilityDollar(item) < 0"
						[isNeutral]="!calcProfitabilityDollar(item)"
						class="text"
					>
						{{ calcProfitabilityDollar(item) | profit: 'dollar' }}
					</span>
					<span
						highlight
						[isPositive]="calcProfitabilityPercent(item) > 0"
						[isNegative]="calcProfitabilityPercent(item) < 0"
						[isNeutral]="!calcProfitabilityPercent(item)"
						class="sub-text"
					>
						{{ calcProfitabilityPercent(item) | profit: 'percent' }}
					</span>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-actions>
			<ng-template let-item="item">
				<app-position-stocks-actions [position]="item" />
			</ng-template>
		</app-table-actions>

		<app-table-footer>
			<ng-template>
				<div class="footer">
					<div class="total">
						<span class="title">{{ 'positions.total' | translate }}:</span>
						<span
							class="value"
							[tuiSkeleton]="isLoadingPositions()"
							>{{ positions().length | quantity }}</span
						>
					</div>
				</div>
			</ng-template>
		</app-table-footer>
	</app-table>
</div>
